import request from '@/utils/request'
// 基本参数设置
export function baseSet(data) {
  return request({
    url: '/v1.0/iwrs/project/set/base',
    method: 'post',
    data
  })
}

// 数据格式
export function dataSetting(data) {
  return request({
    url: '/v1.0/iwrs/project/set/data_format',
    method: 'post',
    data
  })
}
// 志文说少掉一个接口 让我试下
export function dataSettingTwo(data) {
  return request({
    url: '/v1.0/iwrs/project/set/subject',
    method: 'post',
    data
  })
}

// 组合层获取
export function getLayer(data) {
  return request({
    url: '/v1.0/iwrs/project/get/combination_layer',
    method: 'post',
    data
  })
}

// 详细参数设置
export function detailData(data) {
  return request({
    url: '/v1.0/iwrs/project/set/detail',
    method: 'post',
    data
  })
}

//获取edc变量匹配
export function getEDCInputName(params) {
  return request({
    url: '/v1.0/iwrs/edc_synchro/iwrs_get_auto_input_name_c',
    method: 'get',
    params
  })
}